// extracted by mini-css-extract-plugin
module.exports = {"expandIcon":"vsscqN","header":"mbyRhc","categoryPage":"NFZDDy","content":"rQCEsu","expanded":"mJSX9J","colorPicker":"dPVqeG","useColorSetting":"NkQ9A3","titleContainer":"CzUYWl"};